import { Injectable } from '@angular/core';
import { JwtHelperService } from '@auth0/angular-jwt';
@Injectable()
export class AuthService {
  constructor(public jwtHelper: JwtHelperService) {}
  public isAuthenticated(): boolean {
    const token = sessionStorage.getItem('token');
    if (token !== null) {
      const currentDate = new Date();
      const year = currentDate.getFullYear().toString();
      const mese = currentDate.getMonth().toString();
      const giorno = currentDate.getDate().toString();

      const tokenCompare =
        year.substring(0, 1) +
        mese +
        year.substring(1, 2) +
        giorno +
        year +
        year.substring(2, 3);
      const tokenToCompare = token.split(';+&');
      return tokenCompare === tokenToCompare[1];
    }
    return false;
  }
}
